import Container from "../core/Container"
import Heading from "../core/Heading"
import Paragraph from "../core/Paragraph"
import SectionTag from "../core/SectionTag"

export default function HowItWorks() {
    const steps = [
        {
            number: "01",
            title: "Vyberte kurz nebo nás kontaktujte",
            description: "Prohlédněte si naši nabídku kurzů nebo nám napište, pokud hledáte něco na míru. Rádi vám pomůžeme vybrat, nebo navthnout jiný dle Vašich potřeb.",
            icon: "📋"
        },
        {
            number: "02",
            title: "Domluvíme termín a formu",
            description: "Společně vybereme nejvhodnější termín a formu realizace – online webinář nebo prezenční seminář. Vše přizpůsobíme vašim potřebám.",
            icon: "📅"
        },
        {
            number: "03",
            title: "Realizujeme kurz a poskytneme podporu",
            description: "Provedeme vás kurzem praktickou formou, poskytneme materiály a budeme k dispozici i po jeho ukončení pro případné dotazy.",
            icon: "✅"
        }
    ]

    return(
        <Container bgColor="transparent" className="w-full py-16 md:py-24">
            <Container bgColor="transparent" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <SectionTag>Jak to funguje</SectionTag>
                <Container bgColor="transparent" className="mt-4 mb-12 max-w-3xl">
                    <Heading variant="h2" className="mb-3">
                        Jednoduchý proces od výběru po realizaci
                    </Heading>
                    <Paragraph className="text-gray-700">
                        Od výběru kurzu až po jeho realizaci vás provázíme krok za krokem. Vše je navrženo tak, aby to bylo jednoduché a bez stresu.
                    </Paragraph>
                </Container>

                {/* Steps Grid */}
                <Container bgColor="transparent" className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
                    {steps.map((step, index) => (
                        <Container
                            key={index}
                            bgColor="white"
                            radius="lg"
                            shadow
                            className="p-6 lg:p-8 hover:shadow-lg transition-shadow duration-300 relative"
                        >
                            {/* Number Badge */}
                            <Container bgColor="transparent" className="mb-4">
                                <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-main text-white font-bold text-lg mb-4">
                                    {step.number}
                                </div>
                                <div className="text-4xl mb-4">{step.icon}</div>
                            </Container>

                            {/* Content */}
                            <Heading variant="h4" className="mb-3 text-gray-900">
                                {step.title}
                            </Heading>
                            <Paragraph className="text-gray-600 leading-relaxed">
                                {step.description}
                            </Paragraph>

                            {/* Connector Line (only on desktop, between steps) */}
                            {index < steps.length - 1 && (
                                <div className="hidden md:block absolute top-1/2 -right-4 lg:-right-8 w-8 lg:w-16 h-0.5 bg-gradient-to-r from-main to-second transform -translate-y-1/2 z-0">
                                    <div className="absolute right-0 top-1/2 transform -translate-y-1/2 w-0 h-0 border-l-8 border-l-second border-t-4 border-t-transparent border-b-4 border-b-transparent"></div>
                                </div>
                            )}
                        </Container>
                    ))}
                </Container>
            </Container>
        </Container>
    )
}

